import React, { useEffect, Suspense } from "react";
import SkeletonComponent from "components/Website/Skeleton";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setNavigate, logout, logoutStore } from "store/Auth/actions";
import { appendData } from "store/Mode/actions";
import { tokenKey } from "services/Admin/AuthService";

const Authmiddleware = ({
	component: Component,
	layout: Layout,
	routePrefix,
	isAuthProtected,
	panel,
	path,
	setType,
	...rest
}) => {
	const dispatch = useDispatch();

	useEffect(() => {
		setType(panel);
		dispatch(appendData({ panelType: panel }));
	}, [panel]);

	return (
		<Route
			{...rest}
			render={(props) => {
				const token = localStorage.getItem(tokenKey);
				const pathName = props?.location?.pathname;

				// ── user side: clear admin session if somehow still present ──────────
				if (panel === "user") {
					const auth = JSON.parse(localStorage.getItem("vr_auth") || "null");
					if (auth?.userType === "admin") {
						localStorage.removeItem(tokenKey);
						localStorage.removeItem("vr_auth");
						dispatch(logoutStore());
					}
				}

				// ── protected route, no token → save path and redirect to login ──────
				if (isAuthProtected && !token) {
					if (pathName) dispatch(setNavigate(pathName));

					const loginPath = panel === "admin" ? "/admin/login" : "/login";

					return (
						<Redirect
							to={{
								pathname: loginPath,
								state: { from: props.location },
							}}
						/>
					);
				}

				// ── non-protected auth page, already logged in → redirect to home ────
				const authOnlyPaths =
					panel === "admin"
						? [
								"/admin/login",
								"/admin/forget-password",
								"/admin/reset-password",
							]
						: ["/login", "/register", "/forget-password"];
				if (!isAuthProtected && token && authOnlyPaths.includes(pathName)) {
					const homePath = panel === "admin" ? "/admin/bookings" : "/";
					return <Redirect to={{ pathname: homePath }} />;
				}

				// ── render with layout (both auth + non-auth) ─────────────────────────
				return (
					<Layout routePrefix={routePrefix}>
						{/* fallback={panel === "admin" ? null : <SkeletonComponent.Page />}> */}
						<Suspense fallback={<SkeletonComponent.Default />}>
							<Component {...props} />
						</Suspense>
					</Layout>
				);
			}}
		/>
	);
};

Authmiddleware.propTypes = {
	isAuthProtected: PropTypes.bool,
	component: PropTypes.any,
	location: PropTypes.object,
	layout: PropTypes.any,
};

export default Authmiddleware;
